import React from 'react';
import { connect } from 'react-redux';

import { clearErrorField, notValidateUpdateValue, validationAndUpdateValue } from 'components/form-multi/utils';

import { changeFormField, setFieldError, setFieldVisible } from 'actions/formAction';

import update from 'immutability-helper';

import PromoInputWrapper from './PromoInputWrapper';

export default function PromoInputBase(InputComponent, isDetached = false) {
    class ComposedInput extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                isFilled: !!props.field.value || props.focus || props.isFilled,
                isFocused: false,
                isEmptyValue: !props.field.value,
            };

            this.inputRef = React.createRef();
            this.wrapperRef = React.createRef();

            this.handlerBlur = this.handlerBlur.bind(this);
            this.handlerChange = this.handlerChange.bind(this);
            this.handlerFocus = this.handlerFocus.bind(this);
            this.focus = this.focus.bind(this);
        }

        handlerBlur(e) {
            this.setState(
                update(this.state, {
                    isFilled: { $set: !!e.target.value },
                    isEmptyValue: { $set: !e.target.value },
                    isFocused: { $set: false },
                }),
            );
            if (this.props.validateOnBlur) {
                const value = this.props.isFormattedInput ? e.target.value?.toString().replace(/\s+/g, '') : e.target.value;
                let field = this.props.field;
                validationAndUpdateValue(this.props.formName, value, field, this.props.changeFormField).then(() => {
                    if (this.props.onBlurHandler) {
                        this.props.onBlurHandler(value, field.name, field.checkRegexp, field.mandatory);
                    }
                });
            }
        }

        handlerChange(e) {
            notValidateUpdateValue(this.props.formName, e.target.value, this.props.field, this.props.changeFormField).then(() => {
                if (this.props.onChangeHandler) {
                    this.props.onChangeHandler(this.props.field.value, this.props.field.name);
                }
            });
        }

        handlerFocus(e) {
            this.setState(
                update(this.state, {
                    isFilled: { $set: true },
                    isFocused: { $set: true },
                }),
            );
            const isError = this.props.field.isError;
            if (this.props.isClearErrorOnFocus && isError) {
                clearErrorField(this.props.formName, this.props.field, this.props.changeFormField);
            }
            if (this.props.onFocus) {
                this.props.onFocus(e);
            }
        }

        focus(e) {
            if (e.currentTarget) {
                const input = e.currentTarget.firstElementChild;
                input.focus();
            } else {
                console.log('Focus method not support');
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.field !== undefined && this.props.field.value !== prevProps.field.value && !Number.isNaN(this.props.field.value)) {
                this.setState(
                    update(this.state, {
                        isFilled: { $set: !!this.props.field.value },
                    }),
                );
            }
            if (this.props.isFocused !== prevProps.isFocused) {
                this.setState(
                    update(this.state, {
                        isFocused: { $set: this.props.isFocused },
                    }),
                );
            }

            if (this.props.field !== undefined && this.props.scrollToField !== prevProps.scrollToField && this.props.field.name === this.props.scrollToField) {
                this.wrapperRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        render() {
            const field = this.props.field;
            const isDetachedVar = this.props.isDetached ? this.props.isDetached : isDetached;

            if (field === undefined) {
                return false;
            }

            return (
                <PromoInputWrapper
                    forwardedRef={this.wrapperRef}
                    isReadOnly={this.props.isReadOnly || field.isReadOnly}
                    comment={field.comment}
                    commentLong={field.commentLong}
                    name={field.name}
                    isFilled={this.state.isFilled}
                    isFocused={this.state.isFocused}
                    isEmptyValue={this.state.isEmptyValue}
                    isError={field.isError}
                    isShowCustomComment={field.isShowCustomComment}
                    isDetached={isDetachedVar}
                    labelText={field.placeholder}
                    errorMessage={field.errorMessage}
                    setFocus={this.focus}
                    focus={this.props.focus}
                    isPseudoSelect={this.props.isPseudoSelect}
                    leftInputComponent={this.props.leftInputComponent}
                    regexpErrorMessage={field.checkRegexpError}
                    hintButtonClick={this.props.hintButtonClick}
                >
                    <InputComponent
                        {...this.props}
                        inputBaseHandlerBlur={this.handlerBlur}
                        onFocus={this.handlerFocus}
                        onBlur={this.handlerBlur}
                        onChange={this.handlerChange}
                        forwardedRef={this.inputRef}
                    />
                    {this.props.children}
                </PromoInputWrapper>
            );
        }
    }

    ComposedInput.defaultProps = {
        validateOnBlur: true,
        isDetached: false,
        isFormattedInput: false,
        isFocused: false,
    };

    const mapStateToProps = ({ form, messages }, ownProps) => ({
        scrollToField: form[ownProps.formName]?.scrollToField,
        jsMessages: messages.jsMessages,
    });

    return connect(mapStateToProps, { changeFormField, setFieldVisible, setFieldError })(ComposedInput);
}
